var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content"},[_c('Information',{ref:"information"}),_c('Detail'),_c('Variation'),(_vm.marketplaceIntegration)?_c('Marketplace',{ref:"marketplace"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }